module.exports = __webpack_public_path__ + "static/media/zapier_connect_btn.64e1e8d5.svg";